import { render, staticRenderFns } from "./chain-ratio.vue?vue&type=template&id=3aa2dec0&scoped=true&"
import script from "./chain-ratio.vue?vue&type=script&lang=js&"
export * from "./chain-ratio.vue?vue&type=script&lang=js&"
import style0 from "./chain-ratio.vue?vue&type=style&index=0&id=3aa2dec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2dec0",
  null
  
)

export default component.exports